// Improved Collection Dropdown Menu Functionality
document.addEventListener('DOMContentLoaded', function() {
    // Initialize menu functionality
    const navItems = document.querySelectorAll('.nav-item');
    
    // Function to close all open menus except the current one
    function closeOtherMenus(currentItem) {
        navItems.forEach(item => {
            if (item !== currentItem && !item.contains(currentItem)) {
                const dropdown = item.querySelector('.dropdown, .sub-dropdown');
                const arrow = item.querySelector('.pushy-arrow');
                
                if (dropdown) {
                    dropdown.classList.remove('open');
                    if (arrow) arrow.classList.remove('rotate');
                    
                    // Also close any sub-dropdowns
                    const openSubItems = item.querySelectorAll('.nav-item');
                    openSubItems.forEach(subItem => {
                        const subDropdown = subItem.querySelector('.sub-dropdown');
                        const subArrow = subItem.querySelector('.pushy-arrow');
                        
                        if (subDropdown) {
                            subDropdown.classList.remove('open');
                            if (subArrow) subArrow.classList.remove('rotate');
                        }
                    });
                }
            }
        });
    }
    
    // Add click event listeners to all menu items with dropdowns
    navItems.forEach(item => {
        const link = item.querySelector('a');
        const dropdown = item.querySelector('.dropdown, .sub-dropdown');
        const arrow = item.querySelector('.pushy-arrow');
        
        if (dropdown && link) {
            // Only apply click handler to links with dropdowns
            if (link.getAttribute('href') === '#') {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    // Toggle this dropdown
                    const isOpen = dropdown.classList.contains('open');
                    
                    // Close other menus
                    closeOtherMenus(item);
                    
                    // Toggle current menu
                    dropdown.classList.toggle('open');
                    if (arrow) arrow.classList.toggle('rotate');
                    
                    // Add active class to parent when open
                    item.classList.toggle('active', !isOpen);
                });
            }
        }
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
        const isClickInsideMenu = e.target.closest('.nav-list');
        
        if (!isClickInsideMenu) {
            navItems.forEach(item => {
                const dropdown = item.querySelector('.dropdown, .sub-dropdown');
                const arrow = item.querySelector('.pushy-arrow');
                
                if (dropdown) {
                    dropdown.classList.remove('open');
                    if (arrow) arrow.classList.remove('rotate');
                    item.classList.remove('active');
                }
            });
        }
    });
    
    // Enhanced keyboard accessibility
    navItems.forEach(item => {
        const link = item.querySelector('a');
        const dropdown = item.querySelector('.dropdown, .sub-dropdown');
        
        if (link) {
            link.addEventListener('keydown', function(e) {
                // Open dropdown on Enter or Space
                if ((e.key === 'Enter' || e.key === ' ') && dropdown) {
                    e.preventDefault();
                    dropdown.classList.add('open');
                    item.classList.add('active');
                    
                    const arrow = item.querySelector('.pushy-arrow');
                    if (arrow) arrow.classList.add('rotate');
                    
                    // Focus the first dropdown item
                    const firstDropdownLink = dropdown.querySelector('a');
                    if (firstDropdownLink) {
                        setTimeout(() => firstDropdownLink.focus(), 100);
                    }
                }
            });
        }
    });
    
    // Auto-open dropdown that contains active link
    navItems.forEach(item => {
        const hasActiveChild = item.querySelector('.nav-link-collection.active');
        const dropdown = item.querySelector('.dropdown, .sub-dropdown');
        const arrow = item.querySelector('.pushy-arrow');
        
        if (hasActiveChild && dropdown) {
            dropdown.classList.add('open');
            if (arrow) arrow.classList.add('rotate');
            item.classList.add('active');
        }
    });
    
    // Add hover effect for desktop devices
    if (window.innerWidth >= 992) {
        navItems.forEach(item => {
            const link = item.querySelector('a');
            const dropdown = item.querySelector('.dropdown');
            const arrow = item.querySelector('.pushy-arrow');
            
            if (dropdown && link) {
                // Desktop hover behavior
                item.addEventListener('mouseenter', function() {
                    // Only auto-open top-level dropdowns on hover
                    if (dropdown.classList.contains('dropdown')) {
                        dropdown.classList.add('open');
                        if (arrow) arrow.classList.add('rotate');
                        item.classList.add('active');
                    }
                });
                
                item.addEventListener('mouseleave', function() {
                    // Close on mouse leave if not clicked open
                    if (!item.hasAttribute('data-clicked-open')) {
                        dropdown.classList.remove('open');
                        if (arrow) arrow.classList.remove('rotate');
                        item.classList.remove('active');
                    }
                });
                
                // Mark as clicked open to prevent hover close
                link.addEventListener('click', function() {
                    if (dropdown.classList.contains('open')) {
                        item.setAttribute('data-clicked-open', 'true');
                    } else {
                        item.removeAttribute('data-clicked-open');
                    }
                });
            }
        });
    }
});